import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn} from '../../ui_utils/DomUtils'

export interface ReplayHighlightData {
    actionIndex: number
    type: ReplayHighlightType
}

export enum ReplayHighlightType {
    LargestArmy = 0,
    LongestRoad = 1,
    MonopolyPlayed = 2,
    ManyPointsInOneTurn = 3,
}

const replayHighlightTypeToLobbyImage = {
    [ReplayHighlightType.LargestArmy]: LobbyImage.LargestArmy,
    [ReplayHighlightType.LongestRoad]: LobbyImage.LongestRoad,
    [ReplayHighlightType.MonopolyPlayed]: LobbyImage.CardMonopoly,
    [ReplayHighlightType.ManyPointsInOneTurn]: LobbyImage.Admin,
}

export class UIReplaySliderHighlight {
    readonly container: HTMLElement
    readonly data: ReplayHighlightData

    constructor(container: HTMLDivElement, data: ReplayHighlightData) {
        this.container = createDivIn(container, 'replay-slider-highlight')
        this.container.style.gridColumn = `${data.actionIndex + 1}`
        this.container.style.gridRow = '1'

        this.data = data

        createDivIn(this.container, 'replay-slider-highlight-arrow')
        const highlightBodyContainer = createDivIn(this.container, 'replay-slider-highlight-body')
        createImgIn(highlightBodyContainer, replayHighlightTypeToLobbyImage[data.type])
    }
}
